export default __webpack_public_path__ + "static/alphago-ce53a6a197c45e6709071d54d599fca1.png";